import React from 'react';
import PropTypes from 'prop-types';

import { withRouter } from 'core/libs/router';

import Tags from '../Tags';
import Tag from '../Tag';

import { ancestryAttributes } from 'core/utils/prop-types/model';

/**
 * Обертка над Tags которая упрощает использование тегов-рубрик при работе с данными из апи.
 *
 * @author Aleksey Dibrivniy <a.dibrivniy@rambler-co.ru>
 */

function RubricTags(props) {
  const {
    rubrics: {
      meta: {
        ancestry: [
          {
            rubric: tagsRoot,
            children: tagsChildren,
          },
        ],
      },
    },
    match: {
      params: {
        level_1: level1,
        level_2: level2,
      },
    },
    ...otherProps
  } = props;

  if (!tagsChildren.length) return null;

  /**
   * 1. Объединяем tagsRoot и tagsChildren (tagsRoot переопределяем под кнопку 'Все')
   * 2. Определяем активный тег по текущему URL и slug
   * 3. Формируем ссылку
   * 4. Формируем название
   * 5. Отрисовываем тот или иной тип кастомного тега
   */
  const tags = [].concat(tagsRoot, tagsChildren).filter(item => item.attributes.enabled);

  return (
    <Tags titleGap={0} {...otherProps}>
      {tags.map(({
        id,
        attributes: {
          slug,
          root_slug: rootSlug,
          title: tagTitle,
        },
      }) => {
        const isActive = (!level2 && level1 === slug)
          || level2 === slug;

        const link = rootSlug === slug ? `/${level1}` : `/${level1}/${slug}`;
        const name = rootSlug === slug ? 'Все' : tagTitle;

        return isActive ? (
          <Tag
            minWidth={0}
            key={id}
            state='idle'
            type='secondary'
            link={link}
          >
            {name}
          </Tag>
        ) : (
          <Tag
            minWidth={0}
            key={id}
            link={link}
            type='ghost'
          >
            {name}
          </Tag>
        );
      })}
    </Tags>
  );
}

RubricTags.propTypes = {
  /**
   * Данные о рубриках
   */
  rubrics: PropTypes.shape({
    meta: PropTypes.shape({
      ancestry: ancestryAttributes,
    }),
  }).isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      level_1: PropTypes.string.isRequired,
      level_2: PropTypes.string,
    }).isRequired,
  }).isRequired,
};

const RubricTagsWithHOCs = withRouter(RubricTags);
RubricTagsWithHOCs.displayName = 'RubricTags';

export { RubricTags as StorybookComponent };
export default RubricTagsWithHOCs;
